import React from "react"
import PropTypes from "prop-types"
import BtnPrimary from '../form_sections/BtnPrimary'

class ConnectCoinOnboard extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      showLexicoins: false
    }

    this.closeOnboard = this.closeOnboard.bind(this)
    this.renderLexicoins = this.renderLexicoins.bind(this)
  }


  closeOnboard() {
    $.ajax({
  		url: '../turn_off_connect_coin_onboarding',
  		type: 'POST'
  	})
  	window.location.replace("/friends");
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({
        showLexicoins: true
      })
    }, 1500);
  }

  renderLexicoins() {
    if(!this.state.showLexicoins) {
      return null
    }
    return(
      <div style={{margin: 'auto', width: 50}}>
        <div className="lexicoinPresent lexicoin1"></div>
        <div className="lexicoinPresent lexicoin2"></div>
        <div className="lexicoinPresent lexicoin3"></div>
      </div>
    )
  }

  render() {
    return(
      <div className="wrapper_walkthrough connect_coin_onboard">
          <div className="slide_wrapper">
            <div className="slide">
                <div className="form_section" style={{height: '100%'}}>
                    <div className="submit_cancel">
                        <div className="submit">
                            <div className="actions">
                              <h3
                                onClick={() => this.closeOnboard()}
                                className="store_reward_fullprice" style={{cursor: 'pointer'}}>X</h3>
                            </div>
                        </div>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'space-around', height: "90%", alignItems: "center"}}>
                      <div className="">
                        <h4 className="onboardingModalHeader"style={{marginBottom: 0}}>A welcome gift</h4>
                        <h4 className="onboardingModalHeader"style={{marginBottom: 0}}>just for you 😍🎁</h4>
                      </div>
                      <div className="connectImgSlide3">
                        {this.renderLexicoins()}
                      </div>
                      <div>
                        <h4 className="modalSubHeader" style={{marginBottom: 3}}>Use these <span style={{fontWeight: 'bold'}}>Lexicoins</span> to buy things on Lexody!</h4>
                        <BtnPrimary
                          buttonText="Sweet! See my matches."
                          onClick={this.closeOnboard}
                        />
                      </div>
                    </div>
                </div>
            </div>
          </div>
      </div>
    )
  }


}

export default ConnectCoinOnboard
